import { render } from "./AposModalTabs.vue?vue&type=template&id=706422e0&scoped=true"
import script from "./AposModalTabs.vue?vue&type=script&lang=js"
export * from "./AposModalTabs.vue?vue&type=script&lang=js"

import "./AposModalTabs.vue?vue&type=style&index=0&id=706422e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706422e0"],['__file',"modal/ui/apos/components/AposModalTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "706422e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('706422e0', __exports__)) {
    api.reload('706422e0', __exports__)
  }
  
  module.hot.accept("./AposModalTabs.vue?vue&type=template&id=706422e0&scoped=true", () => {
    api.rerender('706422e0', render)
  })

}


export default __exports__